export default __webpack_public_path__ + "static/media/galleryArrowRight.e9e8f9e1.svg";